import React, { Fragment } from "react";

import GreenLogo from "../Innovators/GreenLogo";
import RedLogo from "../Mentors/RedLogo";
import BlueLogo from "../Employers/BlueLogo";

const MessageModal = ({ msg, user, clearMsg, setDonateError }) => {
  return (
    <Fragment>
      <div className="subscription-overlay">
        <div className="subscription-box-confirmation">
          <i
            className={`far fa-times-circle ${
              user && user.role === "innovator"
                ? "green"
                : user && user.role === "mentor"
                ? "red"
                : user && user.role === "employer"
                ? "blue"
                : !user.role
                ? "green"
                : ""
            } fa-3x subscription-x`}
            onClick={() => {
              clearMsg();
              if (setDonateError) {
                setDonateError("");
              }
            }}
          ></i>
          <div className="subscription-type-container">
            {user && user.role === "innovator" && (
              <p className="nav-logo">
                <GreenLogo />
              </p>
            )}
            {user && !user.role && (
              <p className="nav-logo">
                <GreenLogo />
              </p>
            )}
            {user && user.role === "mentor" && (
              <p className="nav-logo">
                <RedLogo />
              </p>
            )}
            {user && user.role === "employer" && (
              <p className="nav-logo">
                <BlueLogo />
              </p>
            )}
            {user && user.role && (
              <h1
                className={`subscription-name ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                Message
              </h1>
            )}
            {user && !user.role && (
              <h1 className="subscription-name green">Message</h1>
            )}
          </div>
          {user && user.role && (
            <div className="sub-grid-three">
              <div className="sub-container">
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div
                      className={`avi-color-border-alt ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                          user && user.avatar
                        }`}
                        className="sub-avi"
                      />
                    </div>
                  </div>
                  <div className="online-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span
                          className={`${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          } name-font bold`}
                        >
                          {user.channelid}
                        </span>
                      </li>
                      <li className="user-online-item">
                        {user && user.firstname}
                      </li>
                      <li className="user-online-item">
                        {user && user.jobtitle}
                      </li>
                      <li className="user-online-item">
                        {user.location && user.location.state},{" "}
                        {user.location && user.location.country}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="sub-grid">
            <p className="user-request-text white">{msg}</p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MessageModal;
